(function () {
  const selectors = {
    modal: '[data-quick-view-modal]',
    content: '[data-quick-view-content]',
    close: '[data-quick-view-close]',
  };

  function money(cents) {
    const value = Number(cents || 0) / 100;
    return value.toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function parsePackSizes(raw) {
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => Number(item)).filter((item) => item > 0);
      }
      if (typeof parsed === 'number') return [parsed];
    } catch (error) {
      return String(raw)
        .replace('[', '')
        .replace(']', '')
        .split(',')
        .map((item) => Number(String(item).trim()))
        .filter((item) => item > 0);
    }

    return [];
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(`${dateString}T00:00:00`);
    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }

  function buildBadge(arrivalDate) {
    if (!arrivalDate) return '';

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const arrival = new Date(`${arrivalDate}T00:00:00`);
    if (Number.isNaN(arrival.getTime())) return '';

    const noveltyLimit = new Date(arrival);
    noveltyLimit.setDate(noveltyLimit.getDate() + 30);

    if (arrival > today) {
      return `<div class="quick-view-product__badge quick-view-product__badge--arrival">📦 Próxima llegada · ${formatDate(arrivalDate)}</div>`;
    }

    if (arrival <= today && today <= noveltyLimit) {
      return '<div class="quick-view-product__badge quick-view-product__badge--new">✨ Novedad · Producto recién llegado</div>';
    }

    return '';
  }

  function getFirstAvailableVariant(product) {
    return product.variants.find((variant) => variant.available) || product.variants[0];
  }

  function getSelectedPack(packSizes, moq, moqApplies) {
    if (!packSizes.length) return null;
    if (!moqApplies) return packSizes[0];
    return packSizes.find((size) => size >= moq) || packSizes[0];
  }

  function buildPackButtons(product, packSizes, moq, moqApplies, selectedPack, isB2B) {
    if (!isB2B) return '';
    if (!packSizes.length) return '';

    return `
      <p style="margin:0 0 6px;font-size:1.3rem;color:#555;">Selecciona el pack:</p>
      <div class="quick-view-packs" data-qv-packs>
        ${packSizes
          .map((size) => {
            const disabled = moqApplies && size < moq;
            const active = size === selectedPack;
            const packPrice = money(product.price * size);
            return `
              <button
                type="button"
                class="quick-view-pack${active ? ' is-active' : ''}"
                data-qv-pack="${size}"
                ${disabled ? 'disabled' : ''}
              >
                ${size} uds — ${packPrice}
              </button>
            `;
          })
          .join('')}
      </div>
    `;
  }

  function buildPrice(product, isB2B, isLogged) {
    if (isB2B) return `<p class="quick-view-product__price">${money(product.price)}</p>`;
    if (isLogged) return '<p class="quick-view-product__notice">Cuenta pendiente de aprobación. El precio se mostrará cuando tu acceso mayorista esté aprobado.</p>';
    return '<p class="quick-view-product__notice">Accede como mayorista para ver precios exclusivos.</p>';
  }
  function getQuickViewWishlistKey() {
  return window.ISLABONITTA_QUICK_VIEW?.wishlistKey || 'islabonitta_wishlist_0';
}

function getQuickViewWishlist() {
  try {
    const raw = localStorage.getItem(getQuickViewWishlistKey());
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function saveQuickViewWishlist(list) {
  localStorage.setItem(getQuickViewWishlistKey(), JSON.stringify(list));
}

function toggleQuickViewWishlist(button) {
  const handle = button.dataset.productHandle;
  if (!handle) return;

  const list = getQuickViewWishlist();
  const index = list.indexOf(handle);
  const isActive = index === -1;

  if (isActive) {
    list.push(handle);
  } else {
    list.splice(index, 1);
  }

  saveQuickViewWishlist(list);

  button.classList.toggle('is-active', isActive);
  button.textContent = isActive ? '♥ En mi lista de deseos' : '♡ Agregar a mi lista de deseos';

  // Sincronizar corazones de cards
  document.querySelectorAll('[data-wishlist-btn]').forEach((cardButton) => {
    if (cardButton.dataset.productHandle !== handle) return;
    cardButton.classList.toggle('wishlist-btn--active', isActive);
  });

  // Actualizar contador e icono del header
  if (typeof window.triggerWishlistPlop === 'function') {
    window.triggerWishlistPlop();
  }
}

function buildWishlistAction(product, isLogged) {
  if (!product || !product.handle) return '';

  if (!isLogged) {
    return `
      <a href="/customer_authentication/login?return_to=%2Fpages%2Fwishlist" class="quick-view-product__button quick-view-product__button--wishlist">
        ♡ Agregar a mi lista de deseos
      </a>
    `;
  }

  const list = getQuickViewWishlist();
  const active = list.indexOf(product.handle) > -1;

  return `
    <button type="button" class="quick-view-product__button quick-view-product__button--wishlist${active ? ' is-active' : ''}" data-qv-wishlist data-product-handle="${product.handle}">
      ${active ? '♥ En mi lista de deseos' : '♡ Agregar a mi lista de deseos'}
    </button>
  `;
}

  function buildActions(product, variant, isB2B, isLogged) {
  const productUrl = product && product.url ? product.url : `/products/${product.handle}`;

  if (!isLogged) {
    return `
      <a href="/pages/registro-b2b" class="quick-view-product__button quick-view-product__button--primary">
        Solicitar acceso mayorista
      </a>
      <a href="${productUrl}" class="quick-view-product__button quick-view-product__button--secondary">
        Ver producto
      </a>
    `;
  }

  if (!isB2B) {
    return `
      <p class="quick-view-product__notice">Cuenta pendiente de aprobación. Podrás comprar cuando tu acceso mayorista esté aprobado.</p>
      <a href="${productUrl}" class="quick-view-product__button quick-view-product__button--secondary">
        Ver producto
      </a>
    `;
  }

  if (!variant || !variant.available) {
    return `
      <button type="button" class="quick-view-product__button quick-view-product__button--disabled" disabled>
        Agotado
      </button>
      <a href="${productUrl}" class="quick-view-product__button quick-view-product__button--secondary">
        Ver producto
      </a>
    `;
  }

  return `
    <button
      type="button"
      class="quick-view-product__button quick-view-product__button--primary"
      data-qv-add-to-cart
      data-variant-id="${variant.id}"
    >
      Agregar al carrito
    </button>
    <a href="${productUrl}" class="quick-view-product__button quick-view-product__button--secondary">
      Ver producto
    </a>
  `;
}

  function setModalOpen(open) {
    const modal = document.querySelector(selectors.modal);
    if (!modal) return;

    modal.hidden = !open;
    document.body.classList.toggle('overflow-hidden', open);
  }

  function renderProduct(product, sourceButton) {
    const settings = window.ISLABONITTA_QUICK_VIEW || {};
    const isLogged = Boolean(settings.isLogged);
    const isB2B = Boolean(settings.isB2B);
    const content = document.querySelector(selectors.content);
    if (!content) return;

    const variant = getFirstAvailableVariant(product);
    const moq = Number(sourceButton.dataset.moq || 1);
    const moqApplies = sourceButton.dataset.moqApplies === 'true';
    const packSizes = parsePackSizes(sourceButton.dataset.packSizes);
    const selectedPack = getSelectedPack(packSizes, moq, moqApplies);
    const initialQuantity = selectedPack || (moqApplies ? moq : 1);
    const step = selectedPack || 1;
    const arrivalDate = sourceButton.dataset.arrivalDate || '';
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const description = product.description ? product.description.replace(/<[^>]*>/g, '').slice(0, 220) : '';

    content.innerHTML = `
      <div class="quick-view-product" data-qv-product data-variant-id="${variant ? variant.id : ''}" data-step="${step}" data-moq="${moq}" data-moq-applies="${moqApplies ? 'true' : 'false'}">
        <div class="quick-view-product__image-wrap">
          ${
            image
              ? `<img src="${image}" alt="${escapeHTML(product.title)}" class="quick-view-product__image" loading="lazy">`
              : ''
          }
        </div>

        <div class="quick-view-product__info">
          <p class="quick-view-product__vendor">Islabonitta</p>
          <h2 id="QuickViewTitle" class="quick-view-product__title">${escapeHTML(product.title)}</h2>
          ${buildBadge(arrivalDate)}
          ${buildPrice(product, isB2B, isLogged)}
          ${buildPackButtons(product, packSizes, moq, moqApplies, selectedPack, isB2B)}

          <div class="quick-view-quantity">
            <button type="button" data-qv-minus aria-label="Reducir cantidad">−</button>
            <input
              type="number"
              data-qv-quantity
              value="${initialQuantity}"
              min="${moqApplies ? moq : 1}"
              step="${step}"
            >
            <button type="button" data-qv-plus aria-label="Aumentar cantidad">+</button>
          </div>

          <p style="margin:0 0 10px;color:#777;font-size:1.25rem;" data-qv-rule-text>
            ${packSizes.length ? `Packs de ${packSizes.join(', ')} unidades` : ''}
            ${moqApplies && moq > 1 ? `${packSizes.length ? ' · ' : ''}Mínimo de ${moq}` : ''}
          </p>

          <div class="quick-view-product__actions">
  ${buildWishlistAction(product, isLogged)}
  ${buildActions(product, variant, isB2B, isLogged)}
</div>

          ${description ? `<p class="quick-view-product__description">${escapeHTML(description)}...</p>` : ''}
        </div>
      </div>
    `;
  }

  function normalizeQuantity(container, value) {
    const moq = Number(container.dataset.moq || 1);
    const moqApplies = container.dataset.moqApplies === 'true';
    const step = Number(container.dataset.step || 1);
    const min = moqApplies ? moq : 1;

    let nextValue = Number(value);
    if (!Number.isFinite(nextValue)) nextValue = min;
    if (nextValue < min) nextValue = min;

    if (step > 1) {
      const remainder = nextValue % step;
      if (remainder !== 0) nextValue += step - remainder;
    }

    return nextValue;
  }

  function changeQuantity(direction) {
    const container = document.querySelector('[data-qv-product]');
    const input = document.querySelector('[data-qv-quantity]');
    if (!container || !input) return;

    const step = Number(container.dataset.step || 1);
    const current = Number(input.value || 0);
    input.value = normalizeQuantity(container, current + step * direction);
  }

  function selectPack(button) {
    const container = document.querySelector('[data-qv-product]');
    const input = document.querySelector('[data-qv-quantity]');
    if (!container || !input || !button) return;

    const pack = Number(button.dataset.qvPack || 1);
    container.dataset.step = String(pack);
    input.step = String(pack);
    input.value = String(pack);

    document.querySelectorAll('.quick-view-pack').forEach((packButton) => {
      packButton.classList.toggle('is-active', packButton === button);
    });
  }

  function addToCart(button) {
  const variantId = button.dataset.variantId;
  const modalProduct = button.closest('[data-qv-product]') || document;
  const quantityInput = modalProduct.querySelector('[data-qv-quantity]');
  const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

  if (!variantId) return;

  button.disabled = true;
  button.textContent = 'Agregando...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
    .then((response) => {
      if (!response.ok) throw new Error('No se pudo agregar al carrito');
      return response.json();
    })
    .then(() => {
      button.textContent = 'Agregado al carrito';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = 'Agregar al carrito';
      }, 1400);

      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          if (window.updateB2BCartMinimumState) {
            window.updateB2BCartMinimumState(cart);
          }
        });
    })
    .catch(() => {
      button.disabled = false;
      button.textContent = 'Error. Inténtalo otra vez';
      setTimeout(() => {
        button.textContent = 'Agregar al carrito';
      }, 1800);
    });
}

  window.openQuickViewFromButton = function (button) {
    if (!button) return;

    const handle = button.dataset.productHandle;
    const content = document.querySelector(selectors.content);
    if (!handle || !content) return;

    content.innerHTML = '<p class="quick-view-modal__loading">Cargando producto...</p>';
    setModalOpen(true);

    fetch(`/products/${handle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error('Producto no encontrado.');
        return response.json();
      })
      .then((product) => renderProduct(product, button))
      .catch(() => {
        content.innerHTML = '<p class="quick-view-product__notice">No se pudo cargar la vista rápida.</p>';
      });
  };

  document.addEventListener('click', function (event) {
    if (event.target.closest(selectors.close)) {
      event.preventDefault();
      setModalOpen(false);
      return;
    }

    const packButton = event.target.closest('[data-qv-pack]');
    if (packButton) {
      event.preventDefault();
      selectPack(packButton);
      return;
    }

    if (event.target.closest('[data-qv-minus]')) {
      event.preventDefault();
      changeQuantity(-1);
      return;
    }

    if (event.target.closest('[data-qv-plus]')) {
      event.preventDefault();
      changeQuantity(1);
      return;
    }
    const wishlistButton = event.target.closest('[data-qv-wishlist]');
if (wishlistButton) {
  event.preventDefault();
  toggleQuickViewWishlist(wishlistButton);
  return;
}
    const addToCartButton = event.target.closest('[data-qv-add-to-cart]');
if (addToCartButton) {
  event.preventDefault();
  addToCart(addToCartButton);
  return;
}
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-qv-quantity]')) return;
    const container = document.querySelector('[data-qv-product]');
    if (!container) return;
    event.target.value = normalizeQuantity(container, event.target.value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setModalOpen(false);
  });
})();
